import { Badge, BadgeVariant } from '@moment/design-system-ui/badge'

import { OrderSide as OrderSideEnum } from '@/types/enums/order'

interface OrderSideProps {
  side:
    | OrderSideEnum.Buy
    | OrderSideEnum.Sell
    | 'bids_wanted'
    | 'offers_wanted'
    | 'hold'
}

export const sideVariantMap: Record<OrderSideProps['side'], BadgeVariant> = {
  [OrderSideEnum.Buy]: BadgeVariant.Success,
  [OrderSideEnum.Sell]: BadgeVariant.Danger,
  bids_wanted: BadgeVariant.Warning,
  offers_wanted: BadgeVariant.Processing,
  hold: BadgeVariant.Neutral,
}

export const sideDisplayMap: Record<OrderSideProps['side'], string> = {
  [OrderSideEnum.Buy]: 'Buy',
  [OrderSideEnum.Sell]: 'Sell',
  bids_wanted: 'Bids Wanted',
  offers_wanted: 'Offers Wanted',
  hold: 'Hold',
}

export function OrderSide({ side }: OrderSideProps) {
  return <Badge variant={sideVariantMap[side]}>{sideDisplayMap[side]}</Badge>
}
